import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  structuredData?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogTitle,
  ogDescription,
  ogImage,
  structuredData,
}: SEOHeadProps) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const metaUpdates: Array<{ selector: string; attr: string; value: string }> = [];

    if (description) {
      metaUpdates.push({ selector: 'meta[name="description"]', attr: 'content', value: description });
    }
    if (keywords) {
      metaUpdates.push({ selector: 'meta[name="keywords"]', attr: 'content', value: keywords });
    }
    if (canonicalUrl) {
      const linkEl = document.querySelector('link[rel="canonical"]');
      if (linkEl) {
        linkEl.setAttribute('href', canonicalUrl);
      }
    }
    if (ogTitle) {
      metaUpdates.push({ selector: 'meta[property="og:title"]', attr: 'content', value: ogTitle });
    }
    if (ogDescription) {
      metaUpdates.push({ selector: 'meta[property="og:description"]', attr: 'content', value: ogDescription });
    }
    if (ogImage) {
      metaUpdates.push({ selector: 'meta[property="og:image"]', attr: 'content', value: ogImage });
    }
    if (ogType) {
      metaUpdates.push({ selector: 'meta[property="og:type"]', attr: 'content', value: ogType });
    }

    metaUpdates.forEach(({ selector, attr, value }) => {
      const el = document.querySelector(selector);
      if (el) {
        el.setAttribute(attr, value);
      }
    });

    if (structuredData) {
      let scriptEl = document.querySelector('#structured-data') as HTMLScriptElement | null;
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.id = 'structured-data';
        scriptEl.type = 'application/ld+json';
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(structuredData);
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogTitle, ogDescription, ogImage, structuredData]);

  return null;
}